import { Button } from '../../components/ui/legacy'

function FormPageHeader({ actionName, disableSubmit, closePopUp }) {
  return (
    <header className="flex justify-items-end">
      <div className="flex flex-col items-end justify-items-end">
        <div className="flex gap-4">
          <Button
            variant={'tertiary'}
            onClickHandler={closePopUp}
            className="border-none !bg-gray-background px-2 py-2 hover:!bg-white"
          >
            Hủy
          </Button>
          <Button type="submit" variant={'primary'} disabled={disableSubmit}>
            {actionName}
          </Button>
        </div>
        {/* <div
            className={`text-red-accent transition-all ${
              disableSubmit ? 'scale-100' : 'scale-0'
            }`}
          >
            Bạn cần điền đúng và đủ các trường để tiếp tục
          </div> */}
      </div>
    </header>
  )
}

export default FormPageHeader
